export default {
    // OfferOne - form fields
    internal_name_hint:        "Interný názov ponuky slúži len pre teba. Nájdeš ho v zozname ponúk.",
    internal_name_placeholder: "Interný názov ponuky",
    internal_name_label:       "Interný názov ponuky",
    title_hint:                'Nadpis cenovej ponuky sa zobrazí ako hlavný nadpis v tvojej cenovej ponuke. Ak ho nevyplníš, zobrazí sa nadpis "Cenová ponuka"',
    client_name_placeholder:   "Názov klienta",
    client_name_label:         "Názov klienta",
    no_client_found:           "Nenašiel sa žiadny klient.",
    add_client_prefix:         '+ Pridať klienta s názvom',
    client_data_hint:          "Údaje klienta sa zobrazia v hornej časti napravo. Údaje sú rozdelené do dvoch stĺpcov. Naľavo odporúčame využiť meno klienta, adresu a napravo napríklad IČO, DIČ, web. Polia sú nepovinné.",
    client_left_placeholder:   "Údaje klienta (ľavý stĺpec)",
    client_left_label:         "Údaje klienta (ľavý stĺpec)",
    client_right_placeholder:  "Údaje klienta (pravý stĺpec)",
    client_right_label:        "Údaje klienta (pravý stĺpec)",
    cover_text_hint:           "Sprievodný text je prvý text, ktorý uvidí tvoj potenciálny klient. Daj si záležať!",
    cover_text_placeholder:    "Sprievodný text",
    cover_text_label:          "Sprievodný text",

    // Buttons & actions
    save:          "Uložiť",
    save_continue: "Uložiť a pokračovať",
    save_finish:   "Uložiť a dokončiť",
    back:          "Späť",
    create:        "Vytvoriť ponuku",

    // Toast messages
    saved_msg:   "Informácie boli uložené.",
    updated_msg: "Cenová ponuka bola aktualizovaná.",
    url_copied:  "URL adresa bola skopírovaná.",

    // Default values (used in data())
    default_title: "Cenová ponuka",

    // Client auto-fill labels
    ico:   "IČO: ",
    dic:   "DIČ: ",
    icdph: "IČ DPH: ",

    // OfferThree / OfferMain
    design_title: "Vzhľad cenovej ponuky",
    preview:      "Náhľad cenovej ponuky",
    step_basic:   "Základné nastavenia",
    step_items:   "Tvorba položiek a pod-položiek",
    step_design:  "Vzhľad cenovej ponuky",

    // OfferRowButtons - actions
    send_mark_unsent:     "Označiť ako neodoslané",
    send_mark_sent:       "Označiť ako odoslané",
    send_tooltip_sent:    "Označiť ako odoslané klientovi",
    send_tooltip_unsent:  "Označiť ako neodoslané klientovi",
    copy_url:             "skopírovať URL",
    copy_url_tooltip:     "Skopírovať URL do schránky",
    open_offer:           "otvoriť ponuku",
    open_offer_tooltip:   "Otvoriť ponuku v novom tabe",
    edit_offer:           "Upraviť ponuku",
    edit_offer_tooltip:   "Upraviť ponuku",
    download_pdf:         "stiahnuť PDF",
    download_pdf_tooltip: "Pre stiahnutie PDF prosím najskôr zverejni ponuku.",
    manage_items_tooltip: "Spravovať položky",
    duplicate_tooltip:    "Duplikovať ponuku",
    history_tooltip:      "História a poznámky",
    delete_tooltip:       "Vymazať ponuku",
    deactivate:           "Deaktivovať ponuku",
    activate:             "Aktivovať ponuku",

    // Delete confirm dialog
    delete_confirm_title: "Určite?",
    delete_confirm_text:  "Naozaj chceš vymazať ponuku?",
    delete_confirm_btn:   "Áno",

    // SendOffer
    send_email_sent_on:     "E-mail odoslaný dňa ",
    send_tooltip:           "Odoslať ponuku e-mailom",
    send_title:             "Odoslať ponuku e-mailom",
    send_sender_ph:         "Odosielateľ",
    send_sender_label:      "Odosielateľ",
    send_to_ph:             "E-mail príjemcu",
    send_to_label:          "E-mail príjemcu",
    send_cc_checkbox:       "Odoslať kópiu",
    send_cc_ph:             "E-mail príjemcu kópie",
    send_cc_label:          "E-mail príjemcu kópie",
    send_message_ph:        "Správa",
    send_message_label:     "Správa",
    send_btn:               "Odoslať e-mail",
    send_history_title:     "História odoslania",
    send_date_col:          "Dátum a čas",
    send_email_col:         "E-mail príjemcu",
    send_cc_prefix:         "Kópia:",
    send_attachments_title: "PRÍLOHY",
    send_upload_feedback:   "Vlož <b data-click='no'>prílohu</b> presunutím alebo <span class='nahraj' data-click='no'>nahraj prílohu</span>",

    // OfferTitleFoto + EntryTitlePhoto (shared)
    title_photo_title:       "Titulná fotka",
    title_photo_hint:        "Nahraj titulnú fotku ponuky. Tá sa zobrazí ako pozadie v hlavičke. Ak nebude nahratá, zobrazí sa predvolené pozadie s verejným názvom ponuky.",
    hide_name_desktop:       "Skryť názov na titulnej fotke (desktop)",
    hide_name_desktop_hint:  "Keď je zapnuté, názov ponuky sa nezobrazí na titulnej fotke. Hodí sa, ak máte vlastnú fotku s",
    hide_name_mobile:        "Skryť názov na titulnej fotke (mobil)",
    uploading:               "Nahrávanie...",
    upload_img_feedback:     "Vlož <b>obrázok</b> presunutím alebo <span class='nahraj'>nahraj obrázok</span>",
    img_remove:              "Vymazať",
    img_download:            "Stiahnuť",
    img_remove_confirm:      "Naozaj chcete vymazať obrázok?",
    img_only_one:            "Je možné nahrať len 1 obrázok. Prosím, najskôr vymažte pôvodný.",
    img_invalid_type:        "Obrázok tohto typu nemôže byť nahratý.",
    img_too_large_suffix:    " je príliš velký! Prosím, výberte obrázok do velikosti ",
    title_photo_mobile_label:  "Titulná fotka mobil",
    title_photo_desktop_label: "Titulná fotka",

    // Entry
    entry_move_up:       "Posunúť položku vyššie",
    entry_duplicate:     "Duplikovať položku",
    entry_move_down:     "Posunúť položku nižšie",
    entry_name_ph:       "Názov položky",
    entry_name_label:    "Názov položky",
    entry_items_db:      "Databáza položiek",
    entry_history:       "História položiek",
    entry_add_desc:      "Pridať popis položky",
    entry_count_from:    "počet od",
    entry_count:         "počet",
    entry_count_to:      "počet do",
    entry_discount:      "Zľava",
    entry_price_vat:     "Vlastná cena bez DPH",
    entry_price:         "Vlastná cena",
    entry_exclude:       "Nezapočítať",
    entry_include:       "Započítať",
    entry_in_total:      "položku do celkovej ceny",
    entry_excluded_msg:  "Táto položka nebude započítaná do celkovej ceny",
    entry_included_msg:  "Táto položka bude započítaná do celkovej ceny",
    entry_expand_sub:    "Rozbaliť podpoložky",
    entry_collapse_sub:  "Zbaliť podpoložky",
    entry_add_sub:       "Pridať podpoložku",
    entry_add_images:    "Pridať obrázky k položke",

    // OfferRow
    row_active_tooltip:   "Ponuka je aktívna a verejná",
    row_inactive_tooltip: "Ponuka je neaktívna a neverejná",
    row_no_client:        "Potrebné priradiť klienta",
    row_updated:          "aktualizované",
    row_created:          "vytvorené",
    row_opened:           "x otvorené",
    row_reset:            "resetovať",
    row_accepted:         "prijaté",
    row_rejected:         "odmietnuté",
    row_status_accepted:  "označená ako akceptovaná. Kliknutím zrušíš tento stav.",
    row_status_rejected:  "označená ako odmietnutá. Kliknutím zrušíš tento stav.",
    row_status_prefix:    "Táto ponuka bola",
    row_status_changed:   "Stav ponuky bol úspešne zmenený",
    row_reset_title:      "Si si istý?",
    row_reset_text:       "Naozaj chceš zrušiť stav ponuky?",
    row_reset_btn:        "Áno",
    row_status_removed:   "Stav ponuky bol odstránený.",
    row_send_unsent:      "Ponuka bola nastavená ako neodoslaná.",
    row_send_sent:        "Ponuka bola nastavená ako odoslaná.",

    // SubEntry
    subentry_name_ph:       "Názov položky",
    subentry_name_label:    "Názov podpoložky",
    subentry_excluded_msg:  "Táto podpoložka nebude započítaná do celkovej ceny tvojej ponuky.",
    subentry_included_msg:  "Táto podpoložka bude započítaná do celkovej ceny tvojej ponuky.",
    subentry_hourly:        "Cena za hodinovú sadzbu",

    // Entry/SubEntry action toolbar
    entry_delete:           "Zmazať položku",
    entry_delete_msg:       "Položka sa natrvalo odstráni z tejto ponuky.",
    entry_save_item:        "Uložiť do Položiek a cien",
    entry_update_item:      "Aktualizovať uloženú položku",
    entry_save_msg:         "Ulož túto položku do svojej databázy, aby si ju mohol rýchlo použiť v ďalších ponukách.",
    entry_update_msg:       "Túto položku už máš uloženú v Položkách a cenách. Klikni pre aktualizáciu na aktuálne hodnoty.",
    subentry_delete:        "Zmazať podpoložku",
    subentry_delete_msg:    "Podpoložka sa natrvalo odstráni z tejto ponuky.",
    subentry_save_item:     "Uložiť do Položiek a cien",
    subentry_update_item:   "Aktualizovať uloženú položku",
    subentry_save_msg:      "Ulož túto podpoložku do svojej databázy, aby si ju mohol rýchlo použiť v ďalších ponukách.",
    subentry_update_msg:    "Túto podpoložku už máš uloženú v Položkách a cenách. Klikni pre aktualizáciu na aktuálne hodnoty.",

    // OfferLegend
    legend_hide:            "Skryť legendu",
    legend_show:            "Zobraziť legendu",
    legend_video:           "Pozrieť video návod",
    legend_client_right:    "Údaje tvojho klienta (pravý stĺpec)",
    legend_client_left:     "Údaje tvojho klienta (ľavý stĺpec)",
    legend_title:           "Verejný nadpis ponuky",
    legend_cover_text:      "Sprievodný text",
    legend_summary:         "Sumárne čísla",
    legend_item:            "Položka",
    legend_item_discount:   "Položka so zľavou",
    legend_subitem:         "Pod-položka",

    // OstatneNastavenia
    other_id_ph:            "Interné ID ponuky",
    other_id_label:         "Interné ID ponuky",
    other_no_firms:         "Aktuálne nemáš pridané žiadne firmy.",
    other_more_firms:       "Máš viacero firiem?",
    other_issue_date:       "Dátum vystavenia ponuky",
    other_valid_date:       "Dátum platnosti ponuky",
    other_en_upsell:        "Chceš mať <b>ponuku po anglicky?</b>",

    // SablonaNaMieru
    template_title:         "Chceš vlastnú unikátnu šablónu?",
    template_desc:          "PREMIUM používateľom ponúkame možnosť tvorby šablóny na mieru. Vieš sa tak úplne odlíšiť od ostatných.",
    template_cta:           "Mám záujem o šablónu na mieru",
    template_modal_title:   "Vlastná šablóna na mieru",
    template_modal_desc:    "Chceš svoje cenové ponuky úplne odlíšiť od ostatných? Vypracujeme ti návrh šablóny na mieru. Stačí vyplniť zopár informácií a tvoje predstavy. My sa ti ozveme s nezáväznou ponukou.",
    template_phone_ph:      "Telefónne číslo",
    template_phone_label:   "Telefónne číslo",

    // VzhladCenovejPonuky
    design_color_title:     "Farebná kombinácia",
    design_later:           "Vzhľad cenovej ponuky môžeš zmeniť aj neskôr.",
    design_custom_color:    "Vlastná farba",
    design_compact_hint:    "Pri zapnutí tejto možnosti bude dizajn využívať menšie medzery a menšie písmo tak, aby bola ponuka kompaktnejšia",
    design_compact_label:   "Kompaktná verzia dizajnu",
    design_hide_logo_hint:  "Ako PREMIUM používateľ máš možnosť skryť naše",

    // OfferOneCheckboxes
    checkbox_accept_title:  "Možnosť prijať alebo odmietnuť cenovú ponuku",
    checkbox_accept_hint:   "V prípade, že zapneš túto možnosť, v ponuke sa zobrazí možnosť prijať, alebo odmietnúť tvoju ponuku. Klient ti tak vie priamo odpovedať pozitívne / negatívne. Budeme ťa o tom informovať mailom.",
    checkbox_delivery_cta:  "Pridať dobu dodania",
    checkbox_delivery_hint: "V prípade, že zapneš túto možnosť, v ponuke sa zobrazí sekcia s dobou dodania. Môžeš zadať dobu dodania a",
    checkbox_reviews_title: "Zobraziť recenzie klientov v ponuke",
    checkbox_reviews_hint:  'Aktivuj túto možnosť a na konci ponuky zobrazíme recenzie tvojich klientov, ktoré si môžeš pridať v sekcii "Recenzie".',

    // OfferFiles
    files_hint:             "Nahraj dokumenty, ktoré majú byť k dispozícii na stiahnutie.",
    files_premium_msg:      "Chceš pridať <b>súbory</b> k tvojej ponuke? <a href='/admin/balicky'> Prejdi na PREMIUM.</a>",
    files_upload_feedback:  "Vlož <b>dokumenty</b> presunutím alebo <span class='nahraj'>nahraj dokumenty</span>",
    files_remove:           "Vymazať",
    files_download:         "Stiahnuť",
    files_remove_confirm:   "Naozaj chcete vymazať dokument?",
    files_only_five:        "Je možné nahrať len 5 dokumentov. Prosím, najskôr vymažte pôvodné.",
    files_invalid_type:     "Dokument tohto typu nemôže byť nahratý.",
    files_too_large_suffix: " je príliš velký! Prosím, výberte dokument do velikosti ",

    // LoadSignature
    sig_label:              "pečiatka / Podpis",
    sig_edit_title:         "Uraviť",
    sig_upload_feedback:    "Vlož <b>podpis</b> alebo <b>pečiatku</b> presunutím alebo <span class='nahraj'>nahraj podpis</span>",
    sig_remove:             "Vymazať",
    sig_download:           "Stiahnuť",
    sig_remove_confirm:     "Naozaj chcete vymazať podpis?",

    // EntryImages
    images_label:           "FOTKY, OBRÁZKY",
    images_upload_feedback: "Vlož <b>obrázky</b> presunutím alebo <span class='nahraj'>nahraj obrázky</span>",
    images_remove:          "Vymazať",
    images_download:        "Stiahnuť",
    images_remove_confirm:  "Naozaj chcete vymazať obrazok?",
    images_only_ten:        "Je možné nahrať len 10 obrazkov. Prosím, najskôr vymaž pôvodné.",
    images_invalid_type:    "Prosím nahrávaj obrázky len vo formáte ",
    images_too_large_suffix:" je príliš velký! Nahraj súbor do veľkosti ",

    // MaxOfferModal
    modal_close:            "Zatvoriť",
    modal_manage_sub:       "Spravovať predplatné",
    modal_offers_counter:   "vytvorených ponúk",
    modal_offers_limit:     "Dosiahol si svoj limit ponúk",
    modal_offers_text:      "V balíčku ZADARMO môžeš vytvoriť <br> <strong>maximálne 3 ponuky</strong>. Ak chceš pridať <br> ďalšiu, prejdi na vyšší balík.",
    modal_clients_counter:  "vytvorených klientov",
    modal_clients_text:     "V balíčku ZADARMO môžeš vytvoriť <br> <strong>maximálne 3 klientov</strong>. Ak chceš pridať <br> ďalšieho, prejdi na vyšší balík.",
    modal_accounts_counter: "využitých prístupov",
    modal_accounts_limit:   "Dosiahol si svoj limit účtov",

    // SendOffer remaining
    send_upload_drop:       "Vlož <b data-click='no'>prílohu</b> presunutím alebo <span class='nahraj' data-click='no'>nahraj prílohu</span>",
    send_file_remove:       "Vymazať",
    send_file_download:     "Stiahnuť",
    send_file_remove_confirm: "Naozaj chcete vymazať prílohu?",
    send_email_subject:     "Cenová ponuka",

    // OffersTable
    table_title:        "Moje cenové ponuky",
    table_header:       "Cenové ponuky",
    clear_filter:       "Premazať filter",
    search_placeholder: "ID, NÁZOV PONUKY, KLIENTA",
    searching:          "Vyhľadávam ponuky…",
    not_found:          "Nenašli sa žiadne ponuky…",
    empty_msg:          "Aktuálne nemáš vytvorené žiadne cenové ponuky. Nechceš nejakú vytvoriť?",
    load_more:          "Načítať ďalšie ponuky",

    // KontaktnaOsoba
    contact_title:       "Kontaktná osoba",
    contact_hint:        "Tento kontakt bude uverejnený v ponuke.",
    contact_phone_ph:    "Telefónne číslo",
    contact_phone_label: "Telefónne číslo",
    contact_add_company: "Pridať firemné alebo iné údaje do ponuky",
    contact_data_hint:   "Údaje, ktoré tu vyplníš, sa zobrazia v spodnej časti",
    contact_company_ph:  "FIREMNÉ alebo DOPLŇUJÚCE údaje v ponuke",
    contact_company_label: "FIREMNÉ alebo DOPLŇUJÚCE údaje v ponuke",

    // Entry - type names (in data())
    entry_type_hourly:    "Cena za hodinovú sadzbu",
    entry_type_range:     "Cenový rozsah od - do",
    entry_type_hour_range:"Hodinový rozsah od - do",
    entry_type_custom:    "Vlastná cena",
    entry_type_subitems:  "Celková cena z podpoložiek",
    entry_add_note:       "Pridať internú poznámku...",

    // OstatneNastavenia - section title + offer languages + datepicker
    other_section_title:  "Ostatné nastavenia",
    other_lang_sk:        "Slovenčina",
    other_lang_cz:        "Čeština",
    other_lang_en:        "Angličtina",
    other_lang_de:        "Nemčina",
    datepicker_months:    "Január,Február,Marec,Apríl,Máj,Jún,Júl,August,September,Október,November,December",
    datepicker_months_short: "Jan,Feb,Mar,Apr,Máj,Jún,Júl,Aug,Sep,Okt,Nov,Dec",
    datepicker_weekdays:  "Nedeľa,Pondelok,Utorok,Streda,Štvrtok,Piatok,Sobota",
    datepicker_weekdays_short: "Ne,Po,Ut,St,Št,Pi,So",

    // SubEntry remaining
    subentry_type_range:     "Cenový rozsah od - do",
    subentry_type_hour_range:"Hodinový rozsah od -do",
    subentry_type_custom:    "Vlastná cena",
    subentry_hours:          "hodín",

    // OfferLegend remaining
    legend_item_gallery:     "Položka s fotkou alebo galériou",
    legend_item_cover:       "Položka s titulnou fotkou",
    legend_accept_option:    "Možnosť prijať alebo odmietnuť ponuku",
    legend_pdf_option:       "Možnosť stiahnuť ponuku ako PDF",
    legend_total_price:      "Celková cena ponuky aj so zľavami",
    legend_company_data:     "Tvoje firemné údaje",
    legend_validity:         "Platnosť ponuky",
    legend_logo:             "Logo DOFFERO, ktoré je možné skryť",
    legend_contact_person:   "Kontaktná osoba",

    // CreatedOfferAlert
    created_alert_published: "Cenová ponuka bola úspešne publikovaná",
    created_alert_url_label: "Cenová ponuka je dostupná online na URL:",
    created_alert_copy_link: "Skopírovať link",
    created_alert_view:      "Zobraziť ponuku",
    created_alert_pdf:       "Stiahnuť PDF",
    created_alert_new:       "Vytvoriť novú cenovú ponuku",
    created_alert_send:      "Odoslať ponuku emailom",

    // SumerneCisla
    summary_title:           "Zobrazenie sumárnych čísiel",
    summary_hint:            "Sumárne čísla sa zobrazia na vrchu cenovej ponuky a obsahujú názov a výslednú cenu každého celku. Je možné pridať maximálne 4 čísla.",
    summary_toggle:          "Zobraziť sumárne čísla",
    summary_name_ph:         "Názov",
    summary_name_label:      "Názov",
    summary_auto_total:      "Pridať automatický súčet nakoniec",
    summary_auto_total_hint: "Ak zaklikneš túto možnosť, na koniec riadku pridáme celkovú cenu tvojej ponuky.",
    summary_add_more:        "+ Pridať ďalšie číslo",
    summary_count:           "zo 3 možných",

    // CompanyUsers
    companyusers_title:       "využitých prístupov",
    companyusers_delete_title:"Čo s vytvorenými ponukami?",
    companyusers_delete_text: "Pri vymazaní je potrebné rozhodnúť, čo spraviť s vytvorenými cenovými ponukami pod kontom tohto používateľa. Prosím, vyber či chceš ponuky zmazať, alebo ich presunúť na svoj účet. Akcia je nezvratná.",
    companyusers_delete_btn:  "Vymazať ponuky",
    companyusers_move_btn:    "Presunúť ponuky",
    companyusers_deleted_msg: "Používateľ bol vymazaný.",
    companyusers_moved_msg:   "Ponuky boli úspešne presunuté a používateľ vymazaný.",

    // FirstLogin remaining
    first_login_offer_url:   "Tvoj odkaz na cenovú ponuku bude vyzerať nasledovne:",
    first_login_prices:      "Nastaviť ceny s",
    first_login_area_ph:     "OBLASŤ PODNIKANIA",
    first_login_area_select: "Kliknutim vyberieš oblasť",
    first_login_area_desel:  "Kliknutim odstrániš oblasť",
    first_login_specify_ph:  "Vieš konkretizovať?",
    first_login_specify_label:"Vieš konkretizovať?",
    first_login_personal_note:"Táto informácia slúži pre zlepšovanie a personalizáciu našich služieb.",
    first_login_complete_btn: "Dokončiť registráciu",
    first_login_slug_taken:  "Takýto odkaz už niekto používa. Skús použiť iný.",
    first_login_no_firma:    "Prosím vyplň názov firmy alebo značky.",

    // OfferTwo
    two_add_item:           "Pridať ďalšiu položku",
    two_add_discount:       "Pridať celkovú zľavu",
    two_hide_total:         "Nezobraziť celkovú cenu v ponuke",
    two_hide_total_hint:    "Pri zvolení tejto možnosti v ponuke vôbec nezobrazíme celkovú cenu.",
    two_view_online:        "Pozrieť ponuku online",
    two_saving:             "Ukladá sa...",
    two_autosaved_prefix:   "Automaticky uložené ",
    two_saved_prefix:       "Uložené ",
    price_total:            "Celková cena: ",
    price_total_vat:        "Celková cena s DPH: ",
    price_total_discount:   "Celková cena po zľave: ",
    price_total_vat_disc:   "Celková cena s DPH po zľave: ",
    price_discount_label:   "Zľava: ",
    price_no_vat_disc:      "Celková cena po zľave bez DPH: ",
    price_vat_with_disc:    "Celková cena po zľave s DPH: ",
    price_no_vat:           "Celková cena bez DPH: ",
    two_delete_title:       "Určite?",
    two_delete_text:        "Naozaj chceš vymazať túto položku?",
    two_delete_btn:         "Áno",

    // EntryImagesModal
    images_modal_title:    "Nahrajte fotky k položke",
    images_modal_add_btn:  "Pridať obrázky k položke",
    images_modal_hint:     "Pridaj si obrázky k tvojej položke. Maximálny počet obrázkov je 10, každý do veľkosti 4 MB.",
    images_modal_cover:    "Pridať titulnú fotku k položke",

    // FirstLoginAfter
    first_after_create_title: "Chcem hneď tvoriť ponuku",
    first_after_create_desc:  "Pusti sa hneď do toho a zisti, ako sa vytvára cenová ponuka v DOFFERO.",
    first_after_create_btn:   "Nová cenová ponuka",
    first_after_setup_title:  "Chcem si nastaviť firemné a kontaktné informácie",
    first_after_setup_desc:   "Nastav si údaje, ktoré sa týkajú tvojej firmy a budú sa zobrazovať v tvojich ponukách. Tieto info môžeš kedykoľvek zmeniť.",
    first_after_setup_btn:    "Nastaviť údaje",
    first_after_help:         "Nevieš ako ďalej? Kontaktuj ma na",

    // AiDescriptionButton
    ai_btn_fill_name:   "Pre použitie AI generovania popisu vyplňte názov položky",
    ai_btn_hint:        "AI vygeneruje profesionálny popis na základe názvu, ale aj sprievodného textu ponuky. Čím konkrétnejší je názov položky alebo popis ponuky, tým lepší popis sa vygeneruje.",
    ai_btn_label:       "Vygenerovať popis cez AI",

    // FilterSelect
    filter_my_users:    "Moji používatelia",
    filter_find_ph:     "NÁJSŤ POUŽÍVATEĽA",
    filter_not_found:   "Používateľ sa nenašiel.",

    // PaidModal
    paid_close:         "Zatvoriť",
    paid_check_payment: "Skontrolovať platbu",
    paid_manage_sub:    "Spravovať predplatné",
    paid_feature_title: "Narazil si na platenú funkciu",
    paid_feature_text:  "<strong>Táto funkcia je platená</strong> a je súčasťou <br> vyššieho balíčku, pretože si myslíme, <br> že za to stojí a prinesie ti veľkú <br> hodnotu. :-)",
    paid_error_title:   "Nepodarilo sa nám sprocesovať tvoju platbu",
    paid_error_text:    "Automatická platba za tvoje predplatné neprešla. Dôvodov môže byt niekoľko - nedostatok prostriedkov, exspirovaná karta či zablokovaná platba. Prejdi do platobnej brány a zaplať znovu.",

    // SuperFaktura
    sf_copy_tooltip:    "Kopírovať ponuku do aplikácie SuperFaktura.sk",
    sf_no_api_tooltip:  "Prepojenie na superfaktúru - potrebné vyplniť API kľúč v nastaveniach integrácií.",
    sf_success_msg:     "Ponuka bola úspešne skopírovana do aplikácie SuperFaktura.sk.",
    sf_go_invoices:     "Prejsť na faktúry",

    // FirstLogin errors
    first_login_area_required: "Táto informácia je povinná.",
    first_login_success: "Registracia bola úspešne dokončená.",

    // SendOffer warnings/errors
    send_warning_five_files:    "Je možné nahrať len 5 dokumentov. Prosím, najskôr vymažte pôvodné.",
    send_warning_too_large:     "Vybrate prílohy sú príliš veľké! Prosím, výberte prílohy do velkosti ",
    send_warning_too_large_mb:  " MB.",
    send_warning_type:          "Príloha tohto typu nemôže byť nahratý.",
    send_warning_file_large:    " je príliš velký! Prosím, výberte prílohu do velikosti ",
    send_warning_subject:       "Treba vyplniť predmet emailu.",
    send_warning_email:         "Treba vyplniť email príjemcu.",
    send_warning_email_format:  "Email príjemcu má zlý format.",
    send_warning_message:       "Treba vyplniť správu.",
    send_success_sent:          "Email úspešne odoslaný.",

    // ThreeOffers
    three_can_create:        "Môžeš vytvoriť ešte",
    three_limit_reached:     "Vyčerpal si svoje aktívne ponuky!",
    three_currently_active:  "Aktuálne máš aktívne",
    three_free_info:         "S DOFFERO FREE máš možnosť",
    three_free_count:        "3 aktívnych ponúk.",
    three_deactivate_hint:   "Potrebuješ ich viac? Deaktivuj staré ponuky",

    // FiveKlients
    five_can_create:       "Môžeš vytvoriť ešte",
    five_limit_reached:    "Vyčerpal si svojích klientov!",
    five_currently:        "Aktuálne máš vytvorených",
    five_free_info:        "S DOFFERO FREE máš možnosť",
    five_free_count:       "pridať si 5 klientov.",
    five_deactivate_hint:  "Potrebuješ ich viac? Vymaž starých klientov alebo",

    // items.vue
    items_searching:       "Vyhľadávam položky",
    items_not_found:       "Nenašli sa žiadne položky…",
    items_load_more:       "Načítať ďalšie položky",

    // ActionCompanyUsers
    access_title:          "Prístupy",
    access_see_mine:       "Používateľ vidí ponuky vytvorené mnou (vlastníkom teamu)",
    access_see_team:       "Používateľ vidí ponuky vytvorené inými členmi tímu",

    // NazovSlug errors (reuse existing)
    // first_login_slug_taken and first_login_no_firma already exist

    // MainUcet
    save_template_btn:     "Uložiť template",
    template_saved_msg:    "Template bol zmenený.",
};